import { SET_SEARCH_TEXT, SET_SEARCH_FOCUS } from '../../constants/search';

export const resetSearch = () => ({
  type: SET_SEARCH_TEXT,
  payload: '',
});

export const setSearchText = (payload) => ({
  type: SET_SEARCH_TEXT,
  payload,
});

export const focusSearch = () => ({
  type: SET_SEARCH_FOCUS,
  payload: true,
});
export const blurSearch = () => ({
  type: SET_SEARCH_FOCUS,
  payload: false,
});
